import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import '../containers/Channel/ChannelInfo/Migration/index.css';

const CircularProgressWithLabel = (props) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', width: '165px', height: '165px' }}>
            <CircularProgress
                sx={{
                    color: 'rgba(255, 255, 255, 0.20)',
                    position: 'absolute',
                }}
                value={100}
                variant="determinate"/>
            <CircularProgress
                variant="determinate"
                {...props}
                sx={(theme) => ({
                    color: 'rgba(255, 255, 255, 0.20)',
                    position: 'absolute',
                    ...theme.applyStyles('dark', {
                        color: 'rgba(255, 255, 255, 0.20)',
                    }),
                })}/>
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Typography
                    className="typography"
                    component="div"
                    sx={{ color: 'text.secondary' }}
                    variant="caption">
                    <p>Queue Position</p>
                    <div>{props.position}</div>
                </Typography>
            </Box>
        </Box>
    );
};

const GradientCircularProgress = (props) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', width: '165px', height: '165px' }}>
            <CircularProgress
                sx={{
                    color: 'rgba(255, 255, 255, 0.20)',
                    position: 'absolute',
                }}
                value={100}
                variant="determinate"/>
            <CircularProgress
                sx={{
                    position: 'absolute',
                    '& .MuiCircularProgress-circle': {
                        stroke: 'url(#gradientStroke)',
                    },
                }}
                value={props.value}
                variant="determinate"
                {...props}/>

            <svg height="0" width="0">
                <defs>
                    <linearGradient id="gradientStroke" x1="0%" x2="100%" y1="0%" y2="0%">
                        <stop stopColor="#7645FF" />
                        <stop offset="1" stopColor="#D61D6A" />
                    </linearGradient>
                </defs>
            </svg>

            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Typography
                    className="typography"
                    component="div"
                    sx={{ color: 'text.secondary', textAlign: 'center' }}
                    variant="caption">
                    <span>{`${Math.round(props.value)}%`}</span>
                </Typography>
            </Box>
        </Box>
    );
};

const CircularWithValueLabel = (props) => {
    return (
        <div className={props.type === 'transfer' ? 'transfer_progress circular_progress_wrapper' : 'circular_progress_wrapper'}>
            {props.type === 'transfer'
                ? <GradientCircularProgress value={props.progress}/>
                : <CircularProgressWithLabel position={props.position} value={props.progress}/>}
        </div>
    );
};

CircularWithValueLabel.propTypes = {
    lang: PropTypes.string,
    position: PropTypes.number,
    progress: PropTypes.number,
    type: PropTypes.string,
};

CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
    position: PropTypes.number,
};

GradientCircularProgress.propTypes = {
    value: PropTypes.number.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
    };
};

export default connect(stateToProps)(CircularWithValueLabel);
